<template>
  <div class="mt-30" v-if="afficherTabBudgetAnnuel">
    <table class="table_budgetaire is-width-100p">
      <tr>
        <td v-for="el in columns.length - columnBudgetCount" :key="el"></td>
        <td
          v-if="columnsBudgetVisibleCount"
          :colspan="columnsBudgetVisibleCount"
          class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-centered">
          {{ libelle }}
        </td>
      </tr>
      <tr>
        <th
          class="th_table_budgetaire is-size-11px has-text-grid-1"
          v-for="(column, iColumn) in columns"
          :key="iColumn">
          {{column.title}}
        </th>
      </tr>

      <tr
        v-for="(data, iData) in dataPanneaux"
        :key="iData">
          <td
            v-for="(column, iColumn) in columns"
            :key="iColumn"
            :class="[`td_table_budgetaire is-size-11px has-text-default ${column.class}`, { 'has-background-sous-contrat': data.estLigneSousContrat }]">
            {{formatContent(data, column)}}
          </td>
      </tr>
      <tr>
        <td v-for="el in columns.length - columnBudgetCount - 1" :key="el"></td>
        <td
          v-if="columnsBudgetVisibleCount"
          class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-centered" rowspan="7">
          {{$t('recapBudgetaire.tableau.total')}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalPrixBrutNegocie">
          {{formatNombre(totalPrixBrutNegocie)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalPrixNet">
          {{formatNombre(totalPrixNet)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalTlpe">
          {{formatNombre(totalTlpe)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalHonoraires">
          {{formatNombre(totalHonoraires)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalHonoraireFraisTraitement">
          {{formatNombre(totalHonoraireFraisTraitement)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalFraisTechnique">
          {{formatNombre(totalFraisTechnique)}}
        </td>
        <td class="td_table_budgetaire is-size-11px has-text-grid-1 has-background-grid-3 has-text-weight-bold has-text-right" v-if="totalPrixTotal">
          {{formatNombre(totalPrixTotal)}}
        </td>
      </tr>
    </table>
    <p class="is-size-11px has-text-default mt-10" v-if="contientLigneSousContrat">
      <span class="legende-sous-contrat has-background-sous-contrat"></span>
      {{$t('recapBudgetaire.legendeSousContrat')}}
    </p>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { formatNombre, formatDate, adressFullStringGetter } from '@/services/general/general';
import { genererPanneauHonoraireForfaitaire } from '@/services/recommandation/gestionHonoraireFortaitaire';
import { LISTE_CATEGORIES_HONORAIRE } from '@/configuration/configPanneau';

const COLUMNS_BUDGET = [
  'prixBudgetBrutNetHTFormat',
  'prixNetFormat',
  'tlpeFormat',
  'honorairesFormat',
  'honoraireFraisTraitementFormat',
  'fraisTechniqueFormat',
  'prixTotalFormat',
];

export default {
  props: {
    societe: Object,
    recomDevis: Object,
    panneaux: {
      type: Array,
      default: () => [],
    },
    libelle: String,
  },
  data() {
    return {
      widthWindow: 0,
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          title: this.$t('recapBudgetaire.tableau.numero'),
          propriety: 'numero',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.ancienPanneau'),
          propriety: 'ancienPanneau',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.reference'),
          propriety: 'referencePanneau',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.regie'),
          propriety: 'regie',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.format'),
          propriety: 'format',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.type'),
          propriety: 'materiel',
          isVisible: this.dataPanneaux.map(el => el.materiel).some(Boolean),
        },
        {
          title: this.$t('recapBudgetaire.tableau.categorie'),
          propriety: 'categorieLibelle',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.dateDebut'),
          propriety: 'dateDebutFormat',
          isVisible: this.dataPanneaux.map(el => el.dateDebutFormat).some(Boolean),
        },
        {
          title: this.$t('recapBudgetaire.tableau.dateFin'),
          propriety: 'dateFinFormat',
          isVisible: this.dataPanneaux.map(el => el.dateFinFormat).some(Boolean),
        },
        {
          title: this.$t('recapBudgetaire.tableau.adresse'),
          propriety: 'adressePanneau',
          isVisible: true,
        },
        {
          title: this.$t('recapBudgetaire.tableau.prixBudgetBrutHT'),
          propriety: 'prixBudgetBrutNetHTFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.prixBudgetBrutNetHTFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.prixNet'),
          propriety: 'prixNetFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.prixNetFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.tlpe'),
          propriety: 'tlpeFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.tlpeFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.honoraires'),
          propriety: 'honorairesFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.honorairesFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.honoraireFraisTraitement'),
          propriety: 'honoraireFraisTraitementFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.honoraireFraisTraitementFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.fraisTechnique'),
          propriety: 'fraisTechniqueFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.fraisTechniqueFormat)
            .some(e => e !== formatNombre(0)),
        },
        {
          title: this.$t('recapBudgetaire.tableau.total'),
          propriety: 'prixTotalFormat',
          class: 'has-text-right',
          isVisible: this.dataPanneaux
            .map(el => el.prixTotalFormat)
            .some(e => e !== formatNombre(0)),
        },
      ];
      return columns.filter(column => column.isVisible);
    },
    columnsBudgetVisibleCount() {
      return this.columns
        .filter(c => COLUMNS_BUDGET.includes(c.propriety) && c.isVisible)
        .length;
    },
    columnBudgetCount() {
      return this.columns.filter(c => COLUMNS_BUDGET.includes(c.propriety)).length
    },
    dataPanneaux() {
      const lignesBase = this.panneaux
        .filter(p => p.actif && p.budgets && p.budgets.length)
        .flatMap(p => p.budgets.map(b => this.panneauBudgetMapper(p, b)));

      const ligneHonoraireForfaitaire = this.recomDevis.lignesCommande.find(lc => {
        return lc.produitId === this.societe.produitIdHonoraireForfaitaire;
      });
      if (ligneHonoraireForfaitaire) {
        const pan = genererPanneauHonoraireForfaitaire(ligneHonoraireForfaitaire.prixUnitaire);
        lignesBase.push(this.panneauBudgetMapper(pan, pan.budgets[0]));
      }

      const lignes = this.panneaux.some(p => p.estPanneauSousContrat && p.actif)
        ? lignesBase
        : lignesBase.filter(l => !l.estPanneauSousContrat);

      return lignes.map((el, i) => ({ ...el, numero: i + 1 }));
    },
    totalPrixBrutNegocie() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.prixBrutNegocie || 0)
        .reduce((a, b) => a + b);
    },
    totalPrixNet() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.prixNet || 0)
        .reduce((a, b) => a + b);
    },
    totalTlpe() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.tlpe || 0)
        .reduce((a, b) => a + b);
    },
    totalHonoraires() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.honoraires || 0)
        .reduce((a, b) => a + b);
    },
    totalHonoraireFraisTraitement() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.honoraireFraisTraitement || 0)
        .reduce((a, b) => a + b);
    },
    totalFraisTechnique() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.fraisTechnique || 0)
        .reduce((a, b) => a + b);
    },
    totalPrixTotal() {
      if (!this.dataPanneaux.length) return 0;
      return this.dataPanneaux
        .map(el => el.budget.prixTotal || 0)
        .reduce((a, b) => a + b);
    },
    total() {
        let totalPrixBrutNegocie = 0;
        let totalPrixNet = 0;
        let totalTlpe = 0;
        let totalHonoraires = 0;
				let totalHonoraireFraisTraitement = 0;
        let totalFraisTechnique = 0;
        let totalPrixTotal = 0;
        if (this.totalPrixBrutNegocie !== undefined) {
          totalPrixBrutNegocie = this.totalPrixBrutNegocie ;
        }
        if (this.totalPrixNet !== undefined) {
          totalPrixNet = this.totalPrixNet ;
        }
        if (this.totalTlpe !== undefined) {
          totalTlpe = this.totalTlpe ;
        }
        if (this.totalHonoraires !== undefined) {
          totalHonoraires = this.totalHonoraires ;
        }
        if (this.totalHonoraireFraisTraitement !== undefined) {
          totalHonoraireFraisTraitement = this.totalHonoraireFraisTraitement ;
        }
        if (this.totalFraisTechnique !== undefined) {
          totalFraisTechnique = this.totalFraisTechnique ;
        }
        if (this.totalPrixTotal !== undefined) {
          totalPrixTotal = this.totalPrixTotal ;
        }
      return totalPrixBrutNegocie
        + totalPrixNet
        + totalTlpe
        + totalHonoraires
				+ totalHonoraireFraisTraitement
        + totalFraisTechnique
        + totalPrixTotal;
    },
    afficherTabBudgetAnnuel() {
      return this.dataPanneaux.length > 0;
    },
    contientLigneSousContrat() {
      return this.dataPanneaux.some(el => el.estLigneSousContrat);
    },
  },
  methods: {
    formatNombre(value) {
      return formatNombre(value);
    },
    resize() {
      this.widthWindow = window.innerWidth;
    },
    formatContent(data, column) {
      if (column.propriety === 'format'
        && data.categorie && LISTE_CATEGORIES_HONORAIRE.includes(data.categorie.libelle)) return '';
      return data[column.propriety];
    },
    panneauBudgetMapper(panneau, budget) {
      const ligne = cloneDeep(panneau);
      ligne.budget = budget;
      ligne.estLigneSousContrat = Boolean(panneau.estPanneauSousContrat || panneau.estRenouvellement);
      ligne.ancienPanneau = ligne.estLigneSousContrat ? 'OUI' : 'NON';
      ligne.adressePanneau = adressFullStringGetter(panneau.adresse);
      ligne.categorieLibelle = panneau.categorie ? panneau.categorie.libelle : '';
      ligne.dateDebutFormat = formatDate(budget.dateDebut);
      ligne.dateFinFormat = formatDate(budget.dateFin);
      ligne.prixBudgetBrutNetHTFormat = formatNombre(budget.prixBrutNegocie);
      ligne.prixNetFormat = formatNombre(budget.prixNet);
      ligne.tlpeFormat = formatNombre(budget.tlpe);
      ligne.honorairesFormat = formatNombre(budget.honoraires);
      ligne.honoraireFraisTraitementFormat = formatNombre(budget.honoraireFraisTraitement);
      ligne.fraisTechniqueFormat = formatNombre(budget.fraisTechnique);
      ligne.prixTotalFormat = formatNombre(budget.prixTotal);
      return ligne;
    }
  },
  created() {
    window.addEventListener('resize', this.resize);
    this.resize();
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
};
</script>
